export const translations = {
  en: {
    // Navbar
    navGetQuotes: "Get Free Quotes",
    navHome: "Home",
    
    // Home Page
    homeTitle: "Car Damaged?",
    homeSubtitle: "Get Best Quotes Fast!",
    homeDamageTypes: "🚗 Dents • Scratches • Collision Damage",
    homeSaveBadge: "💰 SAVE UP TO 70%",
    homeCtaButton: "GET FREE QUOTES NOW",
    homeTrustFree: "Free",
    homeTrustFast: "Fast",
    homeTrustNoObligation: "No Obligation",
    homeHowItWorks: "🚀 How It Works",
    homeStep1Title: "📸 Upload Photos",
    homeStep1Desc: "Take pictures of your car damage",
    homeStep2Title: "📧 We Send to ALL Garages",
    homeStep2Desc: "Your request goes to every body shop",
    homeStep3Title: "💰 Compare & Save",
    homeStep3Desc: "Get quotes in 2 days, choose the best",
    homeCtaBottom: "START NOW - IT'S FREE!",
    
    // Fix It Page
    fixItName: "Full Name",
    fixItNamePlaceholder: "John Doe",
    fixItEmail: "Email Address",
    fixItEmailPlaceholder: "john@example.com",
    fixItPhone: "Phone Number",
    fixItPhonePlaceholder: "+352 123 456 789",
    fixItCarBrand: "Car Brand",
    fixItCarBrandPlaceholder: "Select your car brand",
    fixItVin: "VIN (Vehicle Identification Number)",
    fixItVinPlaceholder: "17-character VIN",
    fixItPhotos: "Upload Body Damage Photos",
    fixItPhotosDesc: "Upload up to 5 photos (max 5MB each)",
    fixItNotes: "Describe the Body Damage",
    fixItNotesPlaceholder: "Please describe the damage in detail...",
    fixItConsent: "I consent to Garagefy sharing my information with body shops in Luxembourg for quote purposes.",
    fixItConsentRequired: "Required",
    fixItSubmit: "Get Free Quotes",
    fixItSubmitting: "Sending...",
  },
  
  fr: {
    // Navbar
    navGetQuotes: "Obtenir des Devis Gratuits",
    navHome: "Accueil",
    
    // Home Page
    homeTitle: "Voiture Endommagée?",
    homeSubtitle: "Obtenez les Meilleurs Devis Rapidement!",
    homeDamageTypes: "🚗 Bosses • Rayures • Dégâts de Collision",
    homeSaveBadge: "💰 ÉCONOMISEZ JUSQU'À 70%",
    homeCtaButton: "OBTENIR DES DEVIS GRATUITS",
    homeTrustFree: "Gratuit",
    homeTrustFast: "Rapide",
    homeTrustNoObligation: "Sans Engagement",
    homeHowItWorks: "🚀 Comment Ça Marche",
    homeStep1Title: "📸 Télécharger des Photos",
    homeStep1Desc: "Prenez des photos des dégâts de votre voiture",
    homeStep2Title: "📧 Nous Envoyons à TOUS les Garages",
    homeStep2Desc: "Votre demande va à chaque carrosserie",
    homeStep3Title: "💰 Comparer et Économiser",
    homeStep3Desc: "Recevez des devis en 2 jours, choisissez le meilleur",
    homeCtaBottom: "COMMENCER MAINTENANT - C'EST GRATUIT!",
    
    // Fix It Page
    fixItName: "Nom Complet",
    fixItNamePlaceholder: "Jean Dupont",
    fixItEmail: "Adresse Email",
    fixItEmailPlaceholder: "jean@exemple.com",
    fixItPhone: "Numéro de Téléphone",
    fixItPhonePlaceholder: "+352 123 456 789",
    fixItCarBrand: "Marque de Voiture",
    fixItCarBrandPlaceholder: "Sélectionnez la marque de votre voiture",
    fixItVin: "NIV (Numéro d'Identification du Véhicule)",
    fixItVinPlaceholder: "NIV de 17 caractères",
    fixItPhotos: "Télécharger des Photos des Dégâts",
    fixItPhotosDesc: "Téléchargez jusqu'à 5 photos (max 5 Mo chacune)",
    fixItNotes: "Décrire les Dégâts",
    fixItNotesPlaceholder: "Veuillez décrire les dégâts en détail...",
    fixItConsent: "J'accepte que Garagefy partage mes informations avec les carrosseries au Luxembourg à des fins de devis.",
    fixItConsentRequired: "Obligatoire",
    fixItSubmit: "Obtenir des Devis Gratuits",
    fixItSubmitting: "Envoi en cours...",
  },
  
  de: {
    // Navbar
    navGetQuotes: "Kostenlose Angebote Erhalten",
    navHome: "Startseite",
    
    // Home Page
    homeTitle: "Auto Beschädigt?",
    homeSubtitle: "Schnell die Besten Angebote Erhalten!",
    homeDamageTypes: "🚗 Dellen • Kratzer • Unfallschäden",
    homeSaveBadge: "💰 BIS ZU 70% SPAREN",
    homeCtaButton: "KOSTENLOSE ANGEBOTE ERHALTEN",
    homeTrustFree: "Kostenlos",
    homeTrustFast: "Schnell",
    homeTrustNoObligation: "Unverbindlich",
    homeHowItWorks: "🚀 So Funktioniert's",
    homeStep1Title: "📸 Fotos Hochladen",
    homeStep1Desc: "Machen Sie Fotos von Ihrem Autoschaden",
    homeStep2Title: "📧 Wir Senden an ALLE Werkstätten",
    homeStep2Desc: "Ihre Anfrage geht an jede Karosserie",
    homeStep3Title: "💰 Vergleichen & Sparen",
    homeStep3Desc: "Erhalten Sie Angebote in 2 Tagen, wählen Sie das Beste",
    homeCtaBottom: "JETZT STARTEN - KOSTENLOS!",
    
    // Fix It Page
    fixItName: "Vollständiger Name",
    fixItNamePlaceholder: "Max Mustermann",
    fixItEmail: "E-Mail-Adresse",
    fixItEmailPlaceholder: "max@beispiel.com",
    fixItPhone: "Telefonnummer",
    fixItPhonePlaceholder: "+352 123 456 789",
    fixItCarBrand: "Automarke",
    fixItCarBrandPlaceholder: "Wählen Sie Ihre Automarke",
    fixItVin: "FIN (Fahrzeug-Identifizierungsnummer)",
    fixItVinPlaceholder: "17-stellige FIN",
    fixItPhotos: "Fotos des Schadens Hochladen",
    fixItPhotosDesc: "Laden Sie bis zu 5 Fotos hoch (max. 5 MB pro Foto)",
    fixItNotes: "Beschreiben Sie den Schaden",
    fixItNotesPlaceholder: "Bitte beschreiben Sie den Schaden im Detail...",
    fixItConsent: "Ich stimme zu, dass Garagefy meine Informationen mit Karosserien in Luxemburg zum Zweck der Angebotserstellung teilt.",
    fixItConsentRequired: "Erforderlich",
    fixItSubmit: "Kostenlose Angebote Erhalten",
    fixItSubmitting: "Wird gesendet...",
  },
  
  lb: {
    // Navbar
    navGetQuotes: "Gratis Offeren Kréien",
    navHome: "Heem",
    
    // Home Page
    homeTitle: "Auto Beschiedegt?",
    homeSubtitle: "Séier déi Bescht Offeren Kréien!",
    homeDamageTypes: "🚗 Beulen • Kraze • Kollisiounsschued",
    homeSaveBadge: "💰 BIS ZU 70% SPUEREN",
    homeCtaButton: "GRATIS OFFEREN KRÉIEN",
    homeTrustFree: "Gratis",
    homeTrustFast: "Séier",
    homeTrustNoObligation: "Ouni Verpflichtung",
    homeHowItWorks: "🚀 Wéi Et Funktionnéiert",
    homeStep1Title: "📸 Fotoen Eroplueden",
    homeStep1Desc: "Maacht Fotoe vun Ärem Autoschued",
    homeStep2Title: "📧 Mir Schécken un ALL Garagen",
    homeStep2Desc: "Är Ufro geet un all Karosserie",
    homeStep3Title: "💰 Vergläichen & Spueren",
    homeStep3Desc: "Kritt Offeren an 2 Deeg, wielt déi Bescht",
    homeCtaBottom: "ELOS UFÄNKEN - ET ASS GRATIS!",
    
    // Fix It Page
    fixItName: "Vollstännegen Numm",
    fixItNamePlaceholder: "Jean Muller",
    fixItEmail: "E-Mail Adress",
    fixItEmailPlaceholder: "jean@beispill.lu",
    fixItPhone: "Telefonsnummer",
    fixItPhonePlaceholder: "+352 123 456 789",
    fixItCarBrand: "Automark",
    fixItCarBrandPlaceholder: "Wielt Är Automark",
    fixItVin: "FIN (Fuerzuch-Identifikatiounsnummer)",
    fixItVinPlaceholder: "17-stelleg FIN",
    fixItPhotos: "Fotoe vum Schued Eroplueden",
    fixItPhotosDesc: "Luet bis zu 5 Fotoen erop (max. 5 MB pro Foto)",
    fixItNotes: "Beschreift de Schued",
    fixItNotesPlaceholder: "Beschreift w.e.g. de Schued am Detail...",
    fixItConsent: "Ech stëmmen zou datt Garagefy meng Informatiounen mat Karosserien zu Lëtzebuerg deelt fir Offerenzwecker.",
    fixItConsentRequired: "Obligatoresch",
    fixItSubmit: "Gratis Offeren Kréien",
    fixItSubmitting: "Gëtt geschéckt...",
  }
};
